<template>
  <div
    ref="textContent"
    class="fe-text-body-xxs lg:fe-text-body-s"
    :class="['fe-overflow-hidden', { 'fe-line-clamp-3': !isExpanded }]"
  >
    {{ content }}
  </div>
</template>

<script>
  export default {
    name: "ReviewContent",
    props: {
      content: {
        type: String,
        default: "",
      },
      isExpanded: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      getElement() {
        return this.$refs.textContent
      },
    },
  }
</script>
